var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2.62268e-07 6.5L6 0.499999L7.425 1.925L2.85 6.5L7.425 11.075L6 12.5L-2.62268e-07 6.5ZM12.6 1.95L14 0.5L20 6.5L14 12.5L12.6 11.05L17.15 6.5L12.6 1.95Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeIcon);
export default __webpack_public_path__ + "static/media/codeIcon.a73d43ea700b9aa310382429eb83647d.svg";
export { ForwardRef as ReactComponent };